module.exports = __webpack_public_path__ + "img/home-page.827017c0.jpg";